import { SnoozeData, SnoozeTime } from "@/protocols/snooze"
import { regexList } from "@/utils/regex"
import {
	getSnoozeTimeInMillisecondsFromFulltimeDateOption,
	snoozeMenuOptions,
	handleInputSnoozeToMilliSeconds,
	getFullDateByTimeAndOption
} from "@/utils/snooze"

export const sanitizeSelectedTime = (selectedTime: string): string => {
	const isNumber = regexList.has_only_number
	const sanitizedTime = selectedTime.replace(isNumber, "")
	const formattedSelectedTime = Number(sanitizedTime) || ""

	return String(formattedSelectedTime)
}

export const sanitizeIncorrectKey = (event: React.KeyboardEvent<HTMLDivElement>) => {
	if (event.key === "," || event.key === "." || event.key === "e") {
		event.preventDefault()
	}
}

const isFullTimeOption = (snoozeData: SnoozeData): boolean => {
	return snoozeData.snoozeTime.timeOption.type === "fullTime"
}

export const calculateSnoozeTimeInMilliseconds = (snoozeData: SnoozeData): number => {
	if (isFullTimeOption(snoozeData) && snoozeData.snoozeTime.fullTime) {
		const snoozeTimeInMilliseconds = getSnoozeTimeInMillisecondsFromFulltimeDateOption(new Date(snoozeData.snoozeTime.fullTime))

		return snoozeTimeInMilliseconds
	}

	const snoozeTimeInMinutes = snoozeMenuOptions[snoozeData.snoozeTime?.timeOption?.type]?.timeInMinutes || 0

	const snoozeTimeInMilliseconds = handleInputSnoozeToMilliSeconds(Number(snoozeData.snoozeTime.time) * snoozeTimeInMinutes)

	return snoozeTimeInMilliseconds
}

export const calculateSnoozeTimeData = (snoozeData: SnoozeData, time: string): SnoozeTime => {
	const formattedSelectedTime = sanitizeSelectedTime(time)
	const selectedSnoozeMenuOption = snoozeData.snoozeTime.timeOption.type
	const snoozeTime = snoozeData.snoozeTime

	if (isFullTimeOption(snoozeData)) {
		return {
			time: String(formattedSelectedTime),
			fullTime: getFullDateByTimeAndOption(formattedSelectedTime, "minutes"),
			timeOption: {
				...snoozeTime.timeOption,
				type: "minutes"
			}
		}
	}

	return {
		time: String(formattedSelectedTime),
		fullTime: getFullDateByTimeAndOption(formattedSelectedTime, selectedSnoozeMenuOption),
		timeOption: snoozeTime.timeOption
	}
}
